/**
 * Created by iamso on 19.09.2019.
 */

const DraugiemPayments = function () {
    RestPayments.call(this, connector.DRAUGIEM, {
        sdk: SdkManager.SDK_DRAUGIEM
    });
};

DraugiemPayments.prototype = Object.create(RestPayments.prototype);
DraugiemPayments.prototype.constructor = DraugiemPayments;

DraugiemPayments.prototype.getDefaultCurrency = function () {
    return "EUR";
};

DraugiemPayments.prototype.getProductId = function (product) {
    return product.id.draugiem;
};

DraugiemPayments.prototype.stopSocialPinger = function () {
    if (this.socialPinger) {
        this.socialPinger.stop();
        delete this.socialPinger;
    }
};

DraugiemPayments.prototype.startSocialPinger = function (purchase, callback, options) {
    this.stopSocialPinger();

    this.socialPinger = new Pinger({
        action: function (callback) {
            console.log(`ask transaction status: ${purchase.paymentId}`);
            connector.platform.callNative("transactions/check", { id: purchase.paymentId }, (code, response) => {
                if (response === undefined) {
                    callback(connector.CODE_PENDING);
                    return;
                }

                console.log("status: ", response.status);
                if (response.status === "FAILED") {
                    callback(connector.CODE_FAILED, { error: response.status });
                } else if (response.status === "OK") {
                    callback(connector.CODE_SUCCEED);
                } else {
                    callback(connector.CODE_PENDING);
                }
            });
        },

        callback: function (code, raw) {
            callback(code === connector.CODE_FAILED ? ERRORS.PURCHASE.UNKNOWN : code, purchase, raw);
        },

        timeoutCode: ERRORS.PURCHASE.TIMEOUT,
        timeout: options && options.timeout
    });
    this.socialPinger.start();
};

DraugiemPayments.prototype.purchaseOpen = function (product, callback) {
    let priceInCents = Math.floor(product.price * 100);

    if (connector.config.debugMode || connector.platform.isTester()) {
        priceInCents = 1;
    }

    const params = {
        price: priceInCents,
        service: product.productId
    };

    connector.platform.callNative("transactions/create", params, (code, response) => {
        console.log(product.productId, code, response);
        if (code !== connector.CODE_SUCCEED) {
            this.bus.trigger("stream:error", `DraugiemPayments.purchase productId:${product.productId} ${JSON.stringify(response)}`);

            callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: response.error.code, message: response.error.description });
            return;
        }

        const purchase = this.createPurchase(response.transaction.id, product);

        this.startSocialPinger(purchase, callback);

        this.setNotifyActiveListener(() => {
            this.startPurchasePinger(purchase, (code) => {
                callback(code ? ERRORS.PURCHASE.UNKNOWN : connector.CODE_SUCCEED, purchase);
            });
            this.startSocialPinger(purchase, callback, {
                timeout: connector.utils.parseInterval("15 seconds")
            });
        });

        draugiemWindowOpen(response.transaction.link, 350, 400, () => {
            console.log("Draugiem payment window close", product.itemId);
            this.notifyActive();
        });
    });
};

DraugiemPayments.prototype.stopPurchaseActions = function () {
    RestPayments.prototype.stopPurchaseActions.call(this);

    this.stopSocialPinger();
};

DraugiemPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.DRAUGIEM);
};